import { ApiClient } from '@/lib/axios/client';
import type {
  AuthRequest,
  CreateBrandRequest,
  SendOtpRequest,
  VerifyOtpRequest,
  VerifyOtpResponse,
  AddTeamMemberRequest,
  UpdateTeamMemberRequest,
  UpdateAccountRequest,
  AuthResponse,
  TeamMember,
  LogoutResponse,
  TokenExpiryResponse,
  SendOtpResponse,
  SwitchAccountRequest,
  SwitchAccountResponse,
  WatiSettings,
  AccountFilters,
  UpdatePhotoRequest,
  UpdateProfileRequest,
} from './types';
import { PaginatedData } from '@/lib/axios/types';

const BASE_PATH = '/v1/accounts';

export class AccountsApi {
    static async userRefreshToken(data: AuthRequest): Promise<AuthResponse> {
        return await ApiClient.put<AuthResponse>(`${BASE_PATH}/user`, data);
    }

    static async businessLogin(data: AuthRequest): Promise<AuthResponse> {
        return await ApiClient.post<AuthResponse>(`${BASE_PATH}/login`, data);
    }

    static async createBrand(data: CreateBrandRequest): Promise<AuthResponse> {
        return await ApiClient.post<AuthResponse>(`${BASE_PATH}/brands`, data);
    }

    static async bypassLogin(identity: string, otp: string): Promise<AuthResponse> {
        return await ApiClient.post<AuthResponse>(`${BASE_PATH}/bypass_login`, { identity, otp });
    }

    static async businessRefreshToken(data: AuthRequest): Promise<AuthResponse> {
        return await ApiClient.put<AuthResponse>(`${BASE_PATH}/login`, data);
    }

    static async sendOtp(data: SendOtpRequest): Promise<SendOtpResponse> {
        return await ApiClient.post<SendOtpResponse>(`${BASE_PATH}/send_otp`, data);
    }

    static async verifyOtp(data: VerifyOtpRequest): Promise<VerifyOtpResponse> {
        return await ApiClient.post<VerifyOtpResponse>(`${BASE_PATH}/verify_otp`, data);
    }

    static async getTeam(): Promise<PaginatedData<TeamMember>> {
        return await ApiClient.get<PaginatedData<TeamMember>>(`${BASE_PATH}/team`);
    }

    static async addTeamMember(data: AddTeamMemberRequest): Promise<TeamMember> {
        return await ApiClient.post<TeamMember>(`${BASE_PATH}/team`, data);
    }

    static async getTeamMember(userId: string): Promise<TeamMember> {
        return await ApiClient.get<TeamMember>(`${BASE_PATH}/team/${userId}`);
    }

    static async updateTeamMember(userId: string, data: UpdateTeamMemberRequest):Promise<TeamMember> {
        return await ApiClient.put<TeamMember>(`${BASE_PATH}/team/${userId}`,data);
    }

    static async deleteTeamMember(userId: string):Promise<TeamMember> {
        return await ApiClient.delete<TeamMember>(`${BASE_PATH}/team/${userId}`);
    }

    static async updateAccount(data: UpdateAccountRequest):Promise<AuthResponse> {
        return await ApiClient.put<AuthResponse>(`${BASE_PATH}`,data);
    }

    static async updateAccountPhoto(accountId: string, data: UpdatePhotoRequest):Promise<AuthResponse> {
        return await ApiClient.put<AuthResponse>(`${BASE_PATH}/${accountId}/photo`,data);
    }

    static async updateAccountProfile(accountId: string, data: UpdateProfileRequest):Promise<AuthResponse> {
        return await ApiClient.put<AuthResponse>(`${BASE_PATH}/${accountId}/profile`,data);
    }

    static async getAccount(filters?: AccountFilters):Promise<AuthResponse> {
        return await ApiClient.get<AuthResponse>(`${BASE_PATH}`,{
            params: filters,
        });
    }

    static async businessLogout():Promise<LogoutResponse> {
        return await ApiClient.post<LogoutResponse>(`${BASE_PATH}/logout`);
    }

    static async switchAccount(data: SwitchAccountRequest):Promise<SwitchAccountResponse> {
        return await ApiClient.post<SwitchAccountResponse>(`${BASE_PATH}/switch`, data);
    }

    static async getTokenExpiry():Promise<TokenExpiryResponse> {
        return await ApiClient.post<TokenExpiryResponse>(`${BASE_PATH}/expiry`);
    }
    
    static async addWatiSettings(data: WatiSettings): Promise<WatiSettings> {
        return await ApiClient.post<WatiSettings>(`${BASE_PATH}/wati`, data);
    }
}
